import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import TopHeader from "./TopHeader";
import MainHeader from "./MainHeader";
import NavigationBar from "./NavigationBar";
import NotificationMessage from "./NotificationMessage";
import { getAdsectiondetails } from "redux/actions";
import { getLocalStorageValue } from 'config/helper';
import MobileHomeSidebar from '../HeaderTheme2/MainHeader/MobileHomeSidebar'
import "./stickey-header.scss";
import TagManager from 'react-gtm-module'

const HeaderTheme2 = () => {

  const dispatch = useDispatch();

  const faviconIcon = useSelector(
    ({ common }) => common.commonDetailsData.header_section.rsa_client_favicon
  );

  const headerSection = useSelector(
    ({ common }) => common.commonDetailsData.header_section
  );

  useEffect(() => {
    if (headerSection?.facebook_meta_pixel_code) {
      var head = document.getElementsByTagName("HEAD")[0];
      var script = document.createElement("noscript");
      var img = document.createElement("img");
      img.height = '1';
      img.width = '1';
      img.style = 'display:none';
      img.src =
        "https://www.facebook.com/tr?id=" + headerSection.facebook_meta_pixel_code + "&ev=PageView&noscript=1";
      script.async = true;
      script.appendChild(img);
      head.appendChild(script);
    }

    if (headerSection?.geofencing_tracking_pixel_code) {
      const adsScript = document.createElement('script');
      adsScript.src = "https://js.adsrvr.org/up_loader.1.1.0.js";
      adsScript.type = "text/javascript";
      document.body.appendChild(adsScript);

      const trackingScript = document.createElement('script');
      trackingScript.type = "text/javascript";
      trackingScript.innerHTML = `
          ttd_dom_ready(function() {
            if (typeof TTDUniversalPixelApi === 'function') {
              var universalPixelApi = new TTDUniversalPixelApi();
              universalPixelApi.init("${headerSection.geofencing_tracking_pixel_advertiser_id}", ["${headerSection.geofencing_tracking_pixel_code}"], "https://insight.adsrvr.org/track/up");
            }
          });
        `;
      document.body.appendChild(trackingScript);
    }

  }, [headerSection]);

  const adsSectionData = useSelector(({ adsection }) => adsection.adsData);
  const [isSticky, setIsSticky] = useState(false);

  const { currentStoreID } = useSelector(({ store }) => store);
  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");
  const clientId = getLocalStorageValue("RSAclient-id");

  const getFaviconEl = () => {
    return document.getElementById("favicon");
  };

  useEffect(() => {
    const favicon = getFaviconEl(); // Accessing favicon element
    favicon.href = faviconIcon;
  }, [faviconIcon]);

  useEffect(() => {
    const body = {
      ClientStoreId: +storeId || 1,
      RSAClientId: clientId,
    };
    adsSectionData && !adsSectionData.length && dispatch(getAdsectiondetails(body));
  }, [dispatch]); // eslint-disable-line


  useEffect(() => {

    if (headerSection.analytic_google_tag_manager_id) {
      const tagManagerArgs = {
        gtmId: `${headerSection.analytic_google_tag_manager_id}`
      }

      TagManager.initialize(tagManagerArgs)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const handleScroll = () => {
    const scroll = window.scrollY;

    if (scroll < 200) {
      setIsSticky(false);
    } else {
      setIsSticky(true);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <div className={`top-sticky-header ${isSticky ? "sticky" : ""}`}>
        <NotificationMessage />
        {/* <TopHeader /> */}
        <MainHeader />
        <NavigationBar />
        <MobileHomeSidebar />
      </div>
    </>
  );
};

export default HeaderTheme2;
